import React from 'react';
import { Helmet } from 'react-helmet';

export default function ConversionTracking() {
    return (
        <Helmet>
          <script>
            {`
              gtag('event', 'conversion', {
                'send_to': 'AW-16911879713/PschCJXUsssaEKGcm4A_'
              });
            `}
          </script>
        </Helmet>
      );
}


